import { formSubmit } from '@hotjar/tracking';

export enum FORM_NAME {
  updatePayment = 'Update payment details v3',
  invoiceDetails = 'Invoice details v3',
  updateInvoiceDetails = 'Update invoice details',
  billingNotifications = 'Update billing notification emails',
}

type FormSubmitProps = {
  name: string;
  submitSuccess: boolean;
  accountId: number;
  errorMessage?: string;
  errorCode?: string;
};

export const trackFormSubmit = ({
  name,
  submitSuccess,
  accountId,
  errorMessage,
  errorCode,
}: FormSubmitProps): void => {
  const data = {
    ...(!submitSuccess && {
      app_form_submit_failure_reason: errorCode ?? '',
      app_form_submit_error_message: errorMessage ?? '',
    }),
  };
  formSubmit({
    name,
    submitSuccess,
    groupData: {
      account_id: accountId,
    },
    data,
  });
};
